import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import newsRouter from './modules/new'
import promoteRouter from './modules/promote'
import settingsRouter from './modules/settings'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false) 如果设置为true，项目将不会显示在侧边栏中（默认为false）
 * alwaysShow: true               if set true, will always show the root menu 如果设置为真，将始终显示根菜单
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu 如果未设置alwaysShow，则当项目有多个子路由时它将变成嵌套模式，否则不显示根菜单
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb 如果设置为noRedirect，则面包屑中不会重定向
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles) 控制页面角色（可以设置多个角色）
    title: 'title'               the name show in sidebar and breadcrumb (recommend set) 名称在侧边栏和面包屑中显示（建议设置）
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false) 如果设置为true，则不会缓存该页（默认值为false）
    affix: true                  if set true, the tag will affix in the tags-view 如果设置为true，则标记将附加在“标记”视图中
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true) 如果设置为false，则该项将隐藏在breadcrumb中（默认值为true）
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set 如果设置路径，侧边栏将突出显示您设置的路径
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements 没有权限要求的基页
 * all roles can be accessed 可以访问所有角色
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/loginticket',
    component: () => import('@/views/login/loginticket'),
    hidden: true
  },
  {
    path: '/returnurl',
    component: () => import('@/views/login/returnurl'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: '首页',
  //       meta: { title: '首页', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // }
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    alwaysShow: true, // will always show the root menu 将始终显示根菜单
    // name: 'Permission',
    meta: {
      title: '概况',
      icon: 'dashboard'
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/home/admin'),
        name: '首页',
        meta: {
          title: '首页',
          affix: true
        }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles  需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  newsRouter,
  promoteRouter,
  settingsRouter, // 设置

  {
    path: 'http://sj.jxhh.com',
    name: 'yuncang',
    component: Layout,
    meta: {
      title: '云仓',
      icon: 'international'

    }
  },
  // 404 page must be placed at the end !!! 404页必须放在末尾
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router 重置路由器
}

export default router
